import { GetArtworkList$Params } from "kreate-server/commands/GetArtworkList/typing";
import { z } from "zod";

export const ArtworkWindow = z.object({
  type: z.literal("artwork-list"),
  fetchParams: GetArtworkList$Params,
});

export type ArtworkWindow = z.infer<typeof ArtworkWindow>;

export function fromArtworkWindow(artworkWindow: ArtworkWindow): string {
  return JSON.stringify(artworkWindow);
}

export function toArtworkWindow(text: string): ArtworkWindow | undefined {
  try {
    const obj = JSON.parse(text);
    return ArtworkWindow.parse(obj);
  } catch {
    return undefined;
  }
}
